var map = {
	"../pages/checkout/checkout.module": [
		445,
		19
	],
	"../pages/dashboard-detail/dashboard-detail.module": [
		446,
		18
	],
	"../pages/dashboard/dashboard.module": [
		447,
		17
	],
	"../pages/fo-arrival/fo-arrival.module": [
		448,
		16
	],
	"../pages/fo-departure/fo-departure.module": [
		449,
		15
	],
	"../pages/fo-info/fo-info.module": [
		450,
		14
	],
	"../pages/fo-inhouse/fo-inhouse.module": [
		451,
		13
	],
	"../pages/fo-inventory/fo-inventory.module": [
		452,
		12
	],
	"../pages/fo-statistic/fo-statistic.module": [
		464,
		11
	],
	"../pages/login/login.module": [
		454,
		10
	],
	"../pages/pos-canceled/pos-canceled.module": [
		453,
		9
	],
	"../pages/pos-dashboard/pos-dashboard.module": [
		455,
		8
	],
	"../pages/pos-ds/pos-ds.module": [
		456,
		7
	],
	"../pages/pos-paid/pos-paid.module": [
		457,
		6
	],
	"../pages/pos-running/pos-running.module": [
		458,
		5
	],
	"../pages/pos-sale/pos-sale.module": [
		459,
		4
	],
	"../pages/pos-status/pos-status.module": [
		460,
		3
	],
	"../pages/pos-table/pos-table.module": [
		461,
		2
	],
	"../pages/pos-transaction/pos-transaction.module": [
		462,
		1
	],
	"../pages/server-details-new/server-details-new.module": [
		463,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 181;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 181
// module chunks = 20